import { create } from 'zustand'
import Database from '../types/Database'

interface DiveStoreState {
  dives: (Database.Dive & { hostHandle?: string | null })[]
  referenceLocation: { lat: number; lng: number } | null
  isLoading: boolean
  error: string | null
  setDives: (dives: (Database.Dive & { hostHandle?: string | null })[]) => void
  setReferenceLocation: (loc: { lat: number; lng: number }) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clear: () => void
}

export const useDiveStore = create<DiveStoreState>(set => ({
  dives: [],
  referenceLocation: null,
  isLoading: false,
  error: null,
  setDives: dives => set({ dives }),
  setReferenceLocation: loc => set({ referenceLocation: loc }),
  setLoading: loading => set({ isLoading: loading }),
  setError: error => set({ error }),
  clear: () =>
    set({ dives: [], referenceLocation: null, isLoading: false, error: null })
}))
